module.exports = __webpack_public_path__ + "img/keypad-white.6c0f130b.svg";